import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 1px 20px 20px 20px;
  width: 100%;
`;

export const AlertContent = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 21px;
    font-size: ${theme.v2.font.sizes.xxs};
    width: 100%;
  `}
`;
